import React from "react";

export default function Gender({ gender, selected, onClick }) {
  const selectedClasses = selected
    ? "bg-slate-800 hover:bg-slate-700 text-white shadow-md"
    : "bg-stone-100 hover:bg-stone-50 text-gray-900";

  // Aria label text should dynamically describe the button's function
  const ariaLabel = `${selected ? "Sélectionné: " : ""}${
    gender === "male" ? "Homme" : "Femme"
  }`;

  return (
    <button
      onClick={onClick}
      className={`cursor-pointer ${selectedClasses} active:bg-slate-600 active:text-white focus:ring focus:ring-slate-300 w-1/2 rounded-lg px-2 sm:px-4 py-4 sm:py-6`}
      aria-label={ariaLabel}
      aria-pressed={selected} // Correctly communicates the toggle state of the button
      role="button" // Explicitly specifies the role for better accessibility
    >
      {gender === "male" ? (
        <div>
          <svg
            className="fill-current w-full"
            xmlns="http://www.w3.org/2000/svg"
            height="48"
            viewBox="0 -960 960 960"
            width="48"
            aria-hidden="true" // Hide SVG from screen readers as it's decorative
          >
            <path d="M823-829v255h-94v-93L573-512q19 30 28.5 63.5T611-380q0 99-69 168t-168 69q-99 0-168-69t-69-168q0-99 69-168t168-69q36 0 68.5 10t62.5 29l156-156h-92v-95h254ZM374.202-523Q314-523 272.5-481.702t-41.5 101.5Q231-320 272.298-278.5t101.5 41.5Q434-237 475.5-278.298t41.5-101.5Q517-440 475.702-481.5t-101.5-41.5Z" />
          </svg>
          <div className="text-sm sm:text-base font-semibold">Homme</div>
        </div>
      ) : (
        <div>
          <svg
            className="fill-current w-full"
            xmlns="http://www.w3.org/2000/svg"
            height="48"
            viewBox="0 -960 960 960"
            width="48"
            aria-hidden="true" // Hide SVG from screen readers as it's decorative
          >
            <path d="M433-92v-80h-80v-88h80v-89q-83-16-136.5-81.206T243-580q0-98.931 69.484-167.966Q381.968-817 480-817t167.516 69.034Q717-678.931 717-580q0 84.588-53.5 149.794Q610-365 527-349v89h80v88h-80v80h-94Zm46.798-345Q540-437 581.5-478.298t41.5-101.5Q623-640 581.702-681.5t-101.5-41.5Q420-723 378.5-681.702t-41.5 101.5Q337-520 378.298-478.5t101.5 41.5Z" />
          </svg>
          <div className="text-sm sm:text-base font-semibold">Femme</div>
        </div>
      )}
    </button>
  );
}
